import { render, staticRenderFns } from "./CompoundEditorCol.vue?vue&type=template&id=4fef3d98&scoped=true"
import script from "./CompoundEditorCol.vue?vue&type=script&lang=js"
export * from "./CompoundEditorCol.vue?vue&type=script&lang=js"
import style0 from "./CompoundEditorCol.vue?vue&type=style&index=0&id=4fef3d98&prod&lang=scss&scoped=true"
import style1 from "./CompoundEditorCol.vue?vue&type=style&index=1&id=4fef3d98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fef3d98",
  null
  
)

export default component.exports